import { ServiceOrder } from "@features/cx/consumerManagement/types";
import { Badge } from "@shared/ui/badge";
import { Calendar, Wrench } from "lucide-react";
import React from "react";

interface ServiceOrderCardProps {
  serviceOrder: any;
  isSelected: boolean;
  onToggle: (serviceOrderId: string) => void;
  currency: string;
}

export const ServiceOrderCard: React.FC<ServiceOrderCardProps> = ({
  serviceOrder,
  isSelected,
  onToggle,
  currency,
}) => {
  const getRequestTypeBadge = (type: any["requestType"]) => {
    const badges: Record<any["requestType"], string> = {
      Services: "bg-blue-100 text-blue-800",
      Complaints: "bg-red-100 text-red-800",
      NSC: "bg-purple-100 text-purple-800",
      Transfer: "bg-green-100 text-green-800",
      Disconnection: "bg-orange-100 text-orange-800",
      Reconnection: "bg-teal-100 text-teal-800",
    };
    return badges[type];
  };

  return (
    <div
      className={`border rounded-lg p-4 cursor-pointer transition-all ${
        isSelected
          ? "border-blue-500 bg-blue-50"
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => onToggle(serviceOrder.id)}
    >
      <div className="flex items-start gap-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded bg-purple-100 flex items-center justify-center">
            <Wrench className="w-5 h-5 text-purple-600" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between mb-2">
            <h4 className="font-semibold text-gray-900">
              {serviceOrder.serviceOrderName}
            </h4>
            <span className="text-lg font-bold text-gray-900">
              {currency} {serviceOrder.totalActualCost ?? "NA"}
            </span>
          </div>

          <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
            <Calendar className="w-4 h-4" />
            <span>{serviceOrder.approvedDate ?? "NA"}</span>
          </div>

          <div className="flex flex-wrap gap-2 mb-2">
            <Badge
              className={getRequestTypeBadge(serviceOrder.requestType ?? "NA")}
            >
              {serviceOrder.requestType ?? "NA"}
            </Badge>
            <Badge className="bg-yellow-100 text-yellow-800">
              {serviceOrder.paymentStatus}
            </Badge>
          </div>

          <div className="text-xs text-gray-500">
            {serviceOrder.serviceOrderId}
          </div>
        </div>
      </div>
    </div>
  );
};
